import React, {Component, useState} from "react";

import styled from "styled-components";
import {authFetch} from "../../config/network";
import {Button} from "../../library/components/core";
const Container = styled.div`
   max-width: 1600px;
    padding: 32px 0;
`;

const initial = {
    community_id: '',
    new_domain: '',
    loading: false,
    mailgun_region: 'us'
};

export default class GodChangeDomain extends Component {
    constructor(props) {
        super(props);

        this.state = initial;
    }

    handleChange(f,v) {
        this.setState({
            [f]: v
        })
    }

    changeDomain() {
        this.setState({
            loading: true
        });

        const res = () => {
            this.setState(initial);
        };

        const payload = this.state;
        authFetch("/superadmin/change-domain", res, res, "POST", {payload});
    }

    render() {

        let {community_id,loading,new_domain,mailgun_region} = this.state;

        return (<Container>
                <div>
                    Community ID
                    <input value={community_id} onChange={(e)=>{this.handleChange('community_id',e.target.value);}} />
                </div>
                <div>
                    New Email Domain
                    <input value={new_domain} onChange={(e)=>{this.handleChange('new_domain',e.target.value);}} />
                </div>
                <div>
                    Mailgun Region
                    <input value={mailgun_region} onChange={(e)=>{this.handleChange('mailgun_region',e.target.value);}} />
                </div>
                <div>
                    <Button loading={loading} text={'Change Domain'} onClick={this.changeDomain.bind(this)}/>
                </div>
            </Container>
        );
    }
}